import FilterTable from "components/MeTable/FilterTable";
import SearchWidget from "components/Tools/SearchWidget";

function SectionHeader(props) {
  const { ctxView, countRecords, activeSearch, handleFilter } = props;
  // console.log(ctxView?.filters);

  if (!ctxView) return null;

  return (
    <div id="section-header" className="w-full md:flex py-3">
      <div className="flex w-full my-2">
        {ctxView?.filters && (
          <FilterTable
            {...props}
            ctxView={ctxView}
            handleFilter={handleFilter}
            countRecords={countRecords}
          />
        )}
        <div className="flex my-auto">
          <div className="bg-stone-700 my-auto mx-3 rounded-full flex items-center justify-center text-white text-sm font-semibold h-9 w-9">
            {countRecords}
          </div>
        </div>
      </div>
      {activeSearch && (
        <div className="w-full my-auto">
          <SearchWidget handleFilter={handleFilter} ctxView={ctxView} />
        </div>
      )}
    </div>
  );
}

export default SectionHeader;
